export default __webpack_public_path__ + "static/account-area-hero-desktop-326c96f170d6bd3151b49f15dbecb562.jpg";